import { Link } from '@tanstack/react-router';
import styled from 'styled-components';

import { color } from '@creditornot/cb-ingredients/design-tokens';
import { CustomTabsItemComponent, Tabs } from '@creditornot/cb-tabs';

import { useDashboardRoute } from './useDashboardRoute';

const StyledTabs = styled(Tabs)`
  border: 1px solid ${color.border};
  border-width: 1px 0;
  flex-shrink: 0;
`;

function getDashboardLink(dashboardId: string): CustomTabsItemComponent {
  // eslint-disable-next-line react/display-name
  return ({ children, className }) => (
    <Link className={className} to="/analytics/$dashboardId" params={{ dashboardId }}>
      {children}
    </Link>
  );
}

export const DashboardTabs = () => {
  const { dashboards, dashboardId } = useDashboardRoute();
  const tabs = dashboards.map(({ id, title }) => ({
    component: getDashboardLink(id),
    id,
    label: title,
  }));

  if (tabs.length < 2) {
    return null;
  }

  return <StyledTabs activeTabId={dashboardId} items={tabs} />;
};
